module.exports = __webpack_public_path__ + "img/capella.6d87766a.svg";